import useGlobal from "hooks/common/use-global"

const usePricingModal = () => {
  const [pricingModalCourse, setPricingModalCourse] = useGlobal(
    "pricingModalCourse",
  )
  const [pricingModalVisible, setPricingModalVisible] = useGlobal(
    "pricingModalVisible",
  )

  return {
    pricingModalCourse,
    setPricingModalCourse,
    pricingModalVisible,
    setPricingModalVisible,
  }
}

export default usePricingModal
